import Empty from "../../../images/orders/empty.svg";

export const EmptyWatchlist = ({ watchlistName }) => {
  return (
    <div className="flex flex-col items-center gap-2">
      <img src={Empty} alt="" />
      <div className="text-p300 font-semibold text-xl">
        Nothing in watchlist!
      </div>
      <div className="font-medium text-center text-sm text-n500 w-60">
        Please add instrument to track in watchlist!
      </div>
    </div>
  );
};
